import { createSlice } from "@reduxjs/toolkit";

const libraryEditSlice = createSlice({
  name: "libraryEdit",
  initialState: {
    isLibraryEditOpen: false,
  },
  reducers: {
    toogleLibraryEdit: (state) => {
      state.isLibraryEditOpen = !state.isLibraryEditOpen;
    },
  },
});

export const { toogleLibraryEdit } = libraryEditSlice.actions;
export default libraryEditSlice.reducer;